import { createCategoriesApi } from "@/v2/api/metadata/categories";
import { createSportsApi } from "@/v2/api/metadata/sports";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { EntityView } from "@/v2/framework/view/types";
import { columns, dynamicColumnSlots } from "./columns";
import { createFilters } from "./filters";
import { createDialogs } from "./dialogs";

const LS_CATEGORIES_FILTERS_KEY = Symbol("categories-filters");

export function createCategoriesView(ctx: BackofficeContext): EntityView {
  const categoriesApi = createCategoriesApi(ctx);
  const sportsApi = createSportsApi(ctx);

  return {
    id: "categories",
    view: [
      {
        type: "grid",
        columns,
        filters: createFilters({ ctx, sportsApi }),
        dynamicColumnSlots,
        dialogs: createDialogs({ ctx, categoriesApi, sportsApi }),
        syncRouteQuery: true,
        syncRouteDialog: true,
        hasExport: true,
        filtersKey: LS_CATEGORIES_FILTERS_KEY,
        allowSaveFilters: true,
        hasSearch: true,
        api: categoriesApi.grid,
      },
    ],
  };
}
